export default {
  SERVER_ENDPOINT: 'https://justlearn-server.herokuapp.com'
};
